"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FeedbackNotification.default;
  }
});
Object.defineProperty(exports, "feedbackNotificationClasses", {
  enumerable: true,
  get: function () {
    return _feedbackNotificationClasses.default;
  }
});
Object.defineProperty(exports, "getFeedbackNotificationSlots", {
  enumerable: true,
  get: function () {
    return _FeedbackNotification.getFeedbackNotificationSlots;
  }
});
var _FeedbackNotification = _interopRequireWildcard(require("./FeedbackNotification"));
var _feedbackNotificationClasses = _interopRequireDefault(require("./feedbackNotificationClasses"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
